import { SVGInterface } from "../../interface";

const CircleRight = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM12 4.00002C7.58172 4.00002 4 7.58174 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C19.995 7.5838 16.4162 4.00498 12 4.00002ZM10.55 17L9.136 15.585L12.671 12.05L9.136 8.51502L10.55 7.10002L15.5 12.05L10.551 17H10.55Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CircleRight;
